import { Box, Typography } from '@mui/material';
import * as Sentry from '@sentry/react';
import React, { FC } from 'react';

export const SentryErrorBoundary: FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <Sentry.ErrorBoundary
      fallback={FallbackComponent}
      beforeCapture={(scope) => {
        scope.setTag('errorBoundary', true);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

const FallbackComponent = () => (
  <Box
    height='100vh'
    width='100vw'
    display='flex'
    alignItems='center'
    justifyContent='center'
    flexDirection='column'
  >
    <Box>
      <Typography variant='h4'>Whoops!</Typography>
    </Box>
    <Box>Something went wrong. Try to reload the page</Box>
  </Box>
);
